/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import styled from 'styled-components';

import { Box, Image, Touchable, Text } from '../base';
import Icons from './resources';

const Container = styled(Box)`
    flex-direction: ${p => (p.horizontal ? 'row' : 'column')};
`;

const StyledTouchable = styled(Touchable)`
    flex-direction: row;
    align-items: center;
`;

const Description = styled(Text).attrs({ fontSize: 'body2' })`
    flex: 1;
`;

const Ellipsis = styled(Text).attrs({
    font: 'primary',
    fontSize: 'body2',
})`
    text-align: center;
    align-self: center;
`;

// ///////////////////////////////////////////////////////////////////

export default class PropertyIconList extends Component {
    static defaultProps = {
        horizontal: false,
        limit: null,
        size: 5,
        duration: 1500,
        spacing: 4,
    };

    shouldComponentUpdate(nextProps) {
        return this.props !== nextProps;
    }

    get features() {
        const filtered = this.props.features.filter(feature => !this.hasFeatureImage(feature.id));
        const features = this.props.limit ? filtered.slice(0, this.props.limit) : filtered;

        // Keep the original length so we can compare this
        // length with the limit property.
        features.length = filtered.length;

        return features;
    }

    getFeatureImage = feature => Icons[feature.id];

    hasFeatureImage(feature) {
        return !!this.getFeatureImage(feature);
    }

    renderEllipsisIfNeeded(features) {
        if (this.props.limit > 0 && features.length > this.props.limit) {
            return (
                <StyledTouchable onPress={this.props.onPressIcon}>
                    <Ellipsis ml={1}>+{features.length - this.props.limit}</Ellipsis>
                </StyledTouchable>
            );
        }
        return null;
    }

    render() {
        const { horizontal, onPressIcon, spacing, size, duration, ...props } = this.props;
        const { features } = this;

        const mv = horizontal ? 0 : `${spacing}px`;
        const mr = horizontal ? `${spacing}px` : 0;

        if (!features.length) {
            return null;
        }

        return (
            <Container horizontal={horizontal} {...props}>
                {features.map(feature => (
                    <StyledTouchable key={feature.id} mv={mv} mr={mr} variant="opacity" onPress={onPressIcon}>
                        <Image h={size} w={size} source={this.getFeatureImage(feature)} duration={duration} />
                        {/*
                        Only show the description text when this component is not rendered in horizontal mode.
                        otherwise there is no room for displaying the text.
                        */}
                        {horizontal || (
                            <Description ml={2} mv={1}>
                                {feature.name}
                            </Description>
                        )}
                    </StyledTouchable>
                ))}
                {/*
                Sometimes we want to display more feature images than fit on the screen (go over the props.limit).
                To inform the enduser there are more feature images than currently display we want to render a
                ellipsis like indicator (+3), so the users know when they tap one of the feature images a overlay
                will appear when all the feature images.
                */}
                {this.renderEllipsisIfNeeded(features)}
            </Container>
        );
    }
}
